import { render } from "./AuthPage.vue?vue&type=template&id=199bd17c&scoped=true&ts=true"
import script from "./AuthPage.vue?vue&type=script&lang=ts"
export * from "./AuthPage.vue?vue&type=script&lang=ts"

import "./AuthPage.vue?vue&type=style&index=0&id=199bd17c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-199bd17c"]])

export default __exports__